var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.validUpdate)?_c(_vm.compName,{tag:"component",staticClass:"update-content"}):_c('h1',[_vm._v("The \""+_vm._s(_vm.$route.params.id)+"\" update doesn't exist yet!")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }